import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers/index.js";
const windowGlobal = typeof window !== "undefined" && window;

const appliedMiddleware = applyMiddleware(thunk);

const middleware = [appliedMiddleware];

// if (windowGlobal) {
//   console.log(process.env.NODE_ENV)

//   if (process.env.NODE_ENV === 'development') {
//     const devtools =
//       window.__REDUX_DEVTOOLS_EXTENSION__ &&
//       window.__REDUX_DEVTOOLS_EXTENSION__()
//     middleware.push(devtools)
//   }
// }

const store = createStore(rootReducer, compose(...middleware));

export default store;
